/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CustomerServiceLevel {
  Rail = "Rail",
  Road = "Road",
  Standard = "Standard",
  Expedited = "Expedited",
  SameDay = "SameDay",
  Rush = "Rush",
  Direct = "Direct",
  Guaranteed = "Guaranteed",
  FullTruck = "FullTruck",
  Intermodal = "Intermodal",
  Intermodal40 = "Intermodal40",
  Flatbed = "Flatbed",
  Air = "Air",
}

export function instanceOfCustomerServiceLevel(value: any): boolean {
  for (const key in CustomerServiceLevel) {
    if (Object.prototype.hasOwnProperty.call(CustomerServiceLevel, key)) {
      if (
        CustomerServiceLevel[key as keyof typeof CustomerServiceLevel] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CustomerServiceLevelFromJSON(json: any): CustomerServiceLevel {
  return CustomerServiceLevelFromJSONTyped(json, false);
}

export function CustomerServiceLevelFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomerServiceLevel {
  return json as CustomerServiceLevel;
}

export function CustomerServiceLevelToJSON(
  value?: CustomerServiceLevel | null,
): any {
  return value as any;
}

export function CustomerServiceLevelToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CustomerServiceLevel {
  return value as CustomerServiceLevel;
}
